import { render, staticRenderFns } from "./BulkCategorySelection.vue?vue&type=template&id=2659cdea&scoped=true&"
import script from "./BulkCategorySelection.vue?vue&type=script&lang=ts&"
export * from "./BulkCategorySelection.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCategorySelection.vue?vue&type=style&index=0&id=2659cdea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659cdea",
  null
  
)

export default component.exports